/**
* 配额管理
*/
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入应用名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData.slice((currentPage-1)*pageSize,currentPage*pageSize)" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;" >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="applicationName" label="应用名称" width="300" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="callToday" label="今日调用量" width="300" show-overflow-tooltip>
      </el-table-column>

<!--      <el-table-column prop="callCeiling" label="免费调用量(次/日)" width="200" show-overflow-tooltip>-->
<!--      </el-table-column>-->

<!--      <el-table-column prop="concurrentCeiling" label="免费并发量(次/秒)" width="170" show-overflow-tooltip>-->
<!--      </el-table-column>-->


      <el-table-column sortable prop="vipCallCeiling" :formatter="formatVipCallCeiling" label="流量包剩余(次)" width="300" show-overflow-tooltip>
      </el-table-column>
<!--      <el-table-column sortable prop="vipCallCeilingDate"  :formatter="formatVipCallCeilingDate" label="流量包有效期" width="200" show-overflow-tooltip>-->
<!--      </el-table-column>-->


<!--      <el-table-column sortable prop="vipConcurrentCeiling" label="并发包(次/秒)" width="130" show-overflow-tooltip>-->
<!--      </el-table-column>-->
<!--      <el-table-column sortable prop="vipConcurrentDate" label="并发包有效期" width="130" show-overflow-tooltip>-->
<!--      </el-table-column>-->


      <el-table-column sortable prop="status" label="状态" width="70" show-overflow-tooltip>
      </el-table-column>


      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handle(scope.$index, scope.row)">提升调用量</el-button>
<!--          <el-button size="mini" @click="handleQps(scope.$index, scope.row)">提升QPS</el-button>-->
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="parseInt(total)" style="margin-top: 1vw">
    </el-pagination>


  </div>
</template>

<script>
import {getAppQuotaList} from '../../api/appMG'

export default {
  data() {
    return {
      // 分页用到的数据
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false, //是显示加载
      title: '添加',
      formInline: {
        name: '',
      },
      listData: [],
    }
  },

  created() {
    this.getAppQuotaList("")
  },
  methods: {

    handleSizeChange(newSize) {
      // pagesize改变触发
      this.pageSize = newSize
    },
    handleCurrentChange(newPage) {
      // 页码改变触发
      this.currentPage = newPage
    },
    formatVipCallCeiling(row, column){
      return row.vipCallCeilingUnlimited ==1?'∞':row.vipCallCeiling
    },
    formatVipCallCeilingDate(row, column){
      return row.vipCallCeilingUnlimited ==1?row.vipCallCeilingUnlimitedDate:row.vipCallCeilingDate
    },

    getAppQuotaList(applicationName) {
      this.loading = true
      getAppQuotaList(
        {
          "userId": this.$store.getters.getUserInfo.userId,
          "applicationName": applicationName
        }
      ).then(response => {
        if (response.status != 200) {
          this.$message.warning(response.message);
        } else {
          this.listData = response.data;
          this.total = this.listData.length;
        }
      }).catch(e => {
        console.log(e)
      })
      this.loading = false
    },
    // 搜索事件
    search() {
      this.getAppQuotaList(this.formInline.name)
    },
    //提额
    handle: function (index, row) {
      this.$router.push({path: '/pay/createOrder', query: {applicationId: row.applicationId}})
    },
    //提升QPS
    handleQps: function (index, row) {
      this.$router.push({path: '/pay/createOrderQps', query: {applicationId: row.applicationId}})
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>






// WEBPACK FOOTER //
// src/views/manage/QuotaManage.vue